// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6035":"f20ef7389c0e3c6f","6681":"1010be09236ac2e1"}[chunkId] + ".js";
};